export const IMAGE_TYPE = {
    BANNER_IMG: "BANNER_IMG",
    DEAL_IMG: "DEAL_IMG",
    PACKAGE_MAP_IMG: "PACKAGE_MAP_IMG",
    DESTINATION_IMG : "DESTINATION_IMG",
    CABIN_IMG: "CABIN_IMG",
    AN_IMG:"AN_IMG",
    BANNER_MOBILE_IMG:"BANNER_MOBILE_IMAGE",
    ENTERTAINMENT_MOBILE_IMAGE:"ENTERTAINMENT_MOBILE_IMAGE",
    POPUP_IMAGE:"POPUP_IMAGE"
}

export const IMAGE_SUB_TYPE = {
    ENGLISH_IMG : "ENGLISH_IMG",
    ENGLISH_MOBILE_IMG : "ENGLISH_MOBILE_IMG",
    TRADITIONAL_CHINESE_IMG: "TRADITIONAL_CHINESE_IMG",
    TRADITIONAL_CHINESE_MOBILE_IMG: "TRADITIONAL_MOBILE_CHINESE_IMG",
    SIMPLIFIED_CHINESE_IMG: "SIMPLIFIED_CHINESE_IMG",
    SIMPLIFIED_CHINESE_MOBILE_IMG: "SIMPLIFIED_CHINESE_MOBILE_IMG",
    BAHASA_IMG: "BAHASA_IMG",
    BAHASA_MOBILE_IMG: "BAHASA_MOBILE_IMG",
}
